import React from "react";
import "../../DoctorDashboard/component-styles.scss";
import { Modal } from "@mui/material";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import Icon from "../../../assets/checked.svg";
import { CONSULTATIONTYPE } from "../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

export default function CloseOngoingAppntModal(props) {
  const {
    currentAppointment,
    ongoingAppointment,
    endConsultationApi,
    startConsultationApi,
    joinVideoCallback,
    closeView,
  } = props;

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  function closeOngoingConsultation() {
    // Call API to close ongoing consultation
    afterLoginApiAxios
      .post(
        "/doctor/close-meeting",
        {
          doctor_id: userId,
          appointment_id: props.appointment_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        C2CConsole.log(response);
        if (response.data) {
          if (response.data.statusCode === 200) {
            closeView();
          } else {
            // TODO: Error handling and logging
          }
        } else {
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  const closeOngoingAppnt = () => {
    if (ongoingAppointment?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      endConsultationApi(ongoingAppointment);
    } else {
      closeOngoingConsultation();
    }

    if (currentAppointment.appointment_type === CONSULTATIONTYPE.INCLINIC) {
      startConsultationApi(currentAppointment);
    } else {
      joinVideoCallback();
    }
    closeView();
  };

  const getDoctorName = () => {
    return (
      (ongoingAppointment?.doctor_prefix_name
        ? ongoingAppointment?.doctor_prefix_name + ". "
        : "") +
      (ongoingAppointment?.doctor_first_name
        ? ongoingAppointment?.doctor_first_name + " "
        : "") +
      (ongoingAppointment?.doctor_middle_name
        ? ongoingAppointment?.doctor_middle_name + " "
        : "") +
      (ongoingAppointment?.doctor_last_name
        ? ongoingAppointment?.doctor_last_name
        : "")
    );
  };

  return (
    <>
      {props.openView ? (
        <Modal
          open={props.openView}
          onClose={props.closeView}
          dialogClassName="close-ongoing-consult"
        >
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="in-progress-modal-wrapper p-3 p-lg-5">
              <div className="d-flex flex-column justify-content-center align-items-center px-1 px-lg-2">
                <img src={Icon} alt="success" />
                <h4 className="text-center mt-3">
                  Consultation already in progress
                </h4>
                <p className="text-center my-2">
                  {getDoctorName()}{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {props.consultation}
                  </span>{" "}
                  consultation with Patient {props.patient_name} is already in
                  progress. Please note by joining a new consultation your
                  previous in progress consultation will be mark as completed.
                </p>
                <p className="text-center my-2 font-weight-bold">
                  Do you still want to continue?
                </p>
                <div className="d-flex flex-row justify-content-center my-3">
                  <button
                    className="btn primary-cta-button rounded-pill px-5 mr-2"
                    onClick={closeOngoingAppnt}
                  >
                    Yes
                  </button>
                  <button
                    className="btn secondary-button rounded-pill px-5"
                    onClick={props.closeView}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
